import * as Sentry from '@sentry/node';

// Main sanitization function for request data
const sanitizeData = (data: unknown) => {
  if (!data || typeof data !== 'object') return data;

  const sanitized: Record<string, unknown> = { ...data };
  if (sanitized.message) {
    sanitized.message = '[REDACTED]';
  }
  return sanitized;
};

// Main Sentry event sanitization
export const sanitizeSentryEvent = (event: Sentry.ErrorEvent) => {
  if (!event) return event;

  // Deep clone to avoid modifying original
  const sanitizedEvent = JSON.parse(JSON.stringify(event));

  if (!sanitizedEvent) return event;

  // Only sanitize request data
  if (sanitizedEvent.request?.data) {
    sanitizedEvent.request.data = sanitizeData(sanitizedEvent.request.data);
  }

  return sanitizedEvent;
};
